

import { EventEmitter } from "@angular/core";
import { HeaderFilter } from "FoxxyInterfaces";



export enum StatusWupSortimentierenEnum
{
Bearbeitet = "BEARBEITET",
Fertig = "FERTIG",
Fertig_Ohne_Aktion = "FERTIG_OHNE_AKTION",
Freigegeben = "FREIGEGEBEN",
Geloescht = "GELOESCHT",
In_Pruefung = "IN_PRUEFUNG",
Neu = "NEU",
Neue_Platzierung = "NEUE_PLATZIERUNG",
Nicht_Freigegeben = "NICHT_FREIGEGEBEN",
NotSet = "NOT_SET",
kein_WorkFlow = "KEIN_WORKFLOW"
}



export class StatusWupSortimentierenDefaults
{

  onError = new EventEmitter<any>();

  static list: StatusWupSortimentierenDef[] = [
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Neu, text: "Neu", iconstyle: "color: gray;", canFilter: true,   },

    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Bearbeitet, text: "Bearbeitet", iconstyle: "color: yellow;"  , canFilter: true   },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.In_Pruefung, text: "In Prüfung", iconstyle: "color: green;"  , canFilter: false   },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Freigegeben, text: "Freigegeben", iconstyle: "color: blue;" , canFilter: false  },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Fertig, text: "Fertig", iconstyle: "color: blue;" , canFilter: true  },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Fertig_Ohne_Aktion, text: "Fertig ohne Bestellung", iconstyle: "color: blue;" , canFilter: true  },

    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Neue_Platzierung, text: "Neue Platzierung", iconstyle: "color: blue;" , canFilter: false  },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Nicht_Freigegeben, text: "Nicht Freigegeben", iconstyle: "color: blue;" , canFilter: false  },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.kein_WorkFlow, text: "Kein Workflow", iconstyle: "color: blue;" , canFilter: true  },
    <StatusWupSortimentierenDef>{value: StatusWupSortimentierenEnum.Geloescht, text: "Gelöscht", iconstyle: "color: blue;" , canFilter: false    },
  ];

  constructor()
  {
  }

  /**Alle erlaubten Wup Stati für die View */
  static getAllowedFilters() : HeaderFilter[]
  {
    let arr = new Array<HeaderFilter>();
    arr = this.list.filter(f=> f.canFilter == true ).map(f => <HeaderFilter>{
      text: f.text,
      value: f.value
    });
    return arr;
  }

  /**Alle erlaubten Stati für JWWS Übertrag */
  static getJWWSFilter() : StatusWupSortimentierenEnum[]
  {
    let arr = new Array<StatusWupSortimentierenEnum>();
    arr = this.list.filter(f=>
      f.value ==  StatusWupSortimentierenEnum.Neu ||
      f.value ==  StatusWupSortimentierenEnum.Bearbeitet ||
      f.value ==  StatusWupSortimentierenEnum.Fertig      ||
      f.value ==  StatusWupSortimentierenEnum.Fertig_Ohne_Aktion
      || f.value ==  StatusWupSortimentierenEnum.kein_WorkFlow
      || f.value ==  StatusWupSortimentierenEnum.Freigegeben
     ).map(f => f.value);
    return arr;
  }

  /**Filter auf die Default/Standard Statis
   * wird initial gesetzt in Filterung
  */
  static getDefaultFilter() : HeaderFilter[]
  {
    let arr = new Array<HeaderFilter>();
    arr = this.list.filter(f=>
              f.value ==  StatusWupSortimentierenEnum.Neu     ).map(f => <HeaderFilter>{
      text: f.text,
      value: f.value
    });
    return arr;
  }

  /**Eine StatusDefintion nach enum holen  */
  static get(e: StatusWupSortimentierenEnum) : StatusWupSortimentierenDef
  {
    return this.list.find(f=> f.value == e);
  }




}

export class StatusWupSortimentierenDef
{
  value: StatusWupSortimentierenEnum;
  text: string;
  iconstyle: string;
  canFilter: boolean;
}

